// Small line icons for the menus: drawn on a 24 grid in currentColor with the outline's round
// caps, so they take the colour of the disc or button they sit in. Decoration only (aria-hidden).

const PATHS = {
  help: 'M9.2 9.2a3 3 0 1 1 4.3 2.7c-.9.5-1.5 1.2-1.5 2.2v.6M12 18h.01',
  back: 'M15 5l-7 7 7 7',
  chevron: 'M9 5l7 7-7 7',
  person: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5c1-3.6 4-5.5 7.5-5.5s6.5 1.9 7.5 5.5',
  people:
    'M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.8-3.2 3.3-5 6.5-5s5.7 1.8 6.5 5M16 4.8a3.4 3.4 0 0 1 0 6.4M18 15.2c1.8.7 3 2.3 3.5 4.8',
  bag: 'M5 8h14l-1.2 12.5H6.2L5 8zM9 8V6.5a3 3 0 0 1 6 0V8',
  ticket: 'M3.5 8V6.5h17V8a2.5 2.5 0 0 0 0 5v4.5h-17V13a2.5 2.5 0 0 0 0-5zM14 6.5v11',
  flag: 'M5.5 21V4M5.5 4.5h12l-2.5 4 2.5 4h-12',
  trophy:
    'M7.5 4h9v5a4.5 4.5 0 0 1-9 0V4zM7.5 6H4.5a3 3 0 0 0 3 4M16.5 6h3a3 3 0 0 1-3 4M12 13.5V17M8.5 20.5h7M9.5 17h5v3.5h-5z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3.5 2',
  park: 'M3.5 20.5v-9L12 5l8.5 6.5v9M9 20.5v-5.5h6v5.5',
  out: 'M14 4.5h4.5v15H14M10 8l-4 4 4 4M6 12h9',
  pause: 'M9 5.5v13M15 5.5v13',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M5.5 18.5l1.7-1.7M16.8 7.2l1.7-1.7',
  key: 'M8 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM11.5 12H21M17.5 12v3M20.5 12v2.5',
  coin: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9 10.5h6M9 13.5h6',
  bell: 'M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15l1.5-2zM10 20.5a2.2 2.2 0 0 0 4 0',
  phone:
    'M7.5 2.5h9a1.5 1.5 0 0 1 1.5 1.5v16a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V4a1.5 1.5 0 0 1 1.5-1.5zM10.5 18.5h3M12 7v6.5M9.5 11l2.5 2.5 2.5-2.5',
  chat: 'M4.5 5.5h15v10h-8l-4.5 4v-4h-2.5v-10zM8.5 9.5h7M8.5 12.5h4.5',
  send: 'M4 12l16-7.5-5 16-3.5-6.5L4 12zM11.5 14l3.5-3.5',
  lock: 'M6.5 11h11v9.5h-11V11zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  pin: 'M9 3.5h6l-1 6 3.5 3.5h-11L10 9.5l-1-6zM12 13v7.5',
  reply: 'M10 7.5L5 12l5 4.5M5.5 12h8a5.5 5.5 0 0 1 5.5 5.5V19',
  plus: 'M12 5v14M5 12h14',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
